import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCart } from '../CartContext';
import { formatCurrency } from "../helper/currency";

function MenuItem(props) {
  const { updateQuantity, itemQuantities } = useCart();
  const menuItem = props.MenuItem;
  const cart = props.cart;

  const [showQSection, setQSection] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const initialQuantity = itemQuantities[menuItem._id]?.quantity || 0;
  const [showCartButton, setShowCartButton] = useState(initialQuantity === 0);
  const quantity = initialQuantity;

  const isAvailable = menuItem.isActive;
  const isOffer = menuItem.offerDescription;

  const handleIncreaseMinQuantity = (minquantity, price) => {
    const newQuantity = minquantity === 0 ? 1 : minquantity;
    updateQuantity(menuItem._id, newQuantity, price);
    setShowCartButton(false);
    props.handleClick(menuItem);
  };

  const handleIncreaseQuantity = () => {
    const newQuantity = quantity + 1;
    updateQuantity(menuItem._id, newQuantity, menuItem.price);
    setShowCartButton(false);
    if (!cart.some(item => item._id === menuItem._id)) {
      props.handleClick(menuItem);
    }
  };

  const handleDecreaseQuantity = () => {
    if (quantity > 0) {
      const newQuantity = quantity - 1;
      updateQuantity(menuItem._id, newQuantity, menuItem.price);
      if (newQuantity === 0) removeItem(menuItem._id);
    }
  };

  const removeItem = (_id) => {
    const updatedCart = cart.filter(item => item._id !== _id);
    props.setCart(updatedCart);
    sessionStorage.setItem("cartValue", JSON.stringify(updatedCart));
    setShowCartButton(true);
  };

  const handleAddToCart = () => {
    handleIncreaseQuantity();
  };


  const handleOpenDetails = () => {
    navigate(`/product/${menuItem._id}`);
  };

  return (
    <div className="col-md-4 mb-3">
      <div
        className="d-flex align-items-center list-card bg-white h-100 rounded overflow-hidden position-relative shadow-sm"
        style={{ cursor: "pointer" }}
        onClick={handleOpenDetails}
      >

        <div className="list-card-image position-relative">
          {isAvailable === 0 && <div className="card-badge">SOLD OUT</div>}
          {isOffer && <div className="offer-badge">{isOffer}</div>}
          <img
            loading="lazy"
            alt={menuItem.productName}
            src={
              menuItem.images?.length > 0
                ? `${process.env.REACT_APP_IMAGE_BASE_URL}${menuItem.images[0]}`
                : "/placeholder.png"
            }
            className="img-fluid item-img w-100"
          />
        </div>

        <div className="p-3 position-relative flex-grow-1">
          <div className="list-card-body">
            <h6 className="mb-1">
              <span className="text-black text-wrap">{menuItem.productName}</span>
            </h6>

            {/* <p className="text-gray text-wrap mb-3">{menuItem.description}</p> */}

            {menuItem.variants?.length > 0 && menuItem.variants[0].offerPrice ? (
              (() => {
                const originalPrice = menuItem.variants[0].price;
                const offerPrice = menuItem.variants[0].offerPrice;
                const discount = Math.round(((originalPrice - offerPrice) / originalPrice) * 100);
                return (
                  <>
                    <div style={{ textDecoration: 'line-through', color: 'red' }} className="d-flex align-items-center pl-2 pb-1 pt-0">
                      {formatCurrency(originalPrice)}
                    </div>
                    <p className="text-gray mb-3 time">
                      <span className="bg-light text-dark bg-white rounded-sm pl-2 pb-1 pt-1 pr-2">
                        <strong className="h6 font-weight-bolder">{formatCurrency(offerPrice)}</strong>
                        <span style={{
                          color: 'green',
                          backgroundColor: '#DFF6DD',
                          marginLeft: '8px',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          padding: '2px 6px',
                          borderRadius: '4px'
                        }}>{discount}% OFF</span>
                      </span>
                    </p>
                  </>
                );
              })()
            ) : (
              <p className="text-gray mb-3 time">
                <span className="bg-light text-dark bg-white rounded-sm pl-2 pb-1 pt-1 pr-2">
                  <strong className="h6 font-weight-bolder">{formatCurrency(menuItem.variants[0].price)}</strong>
                </span>
              </p>
            )}

            {showQSection && menuItem.quantitySections?.map((offeritem, index1) => (
              <p className="text-gray mb-3 time" key={index1}>
                <span className="bg-light text-dark bg-white rounded-sm pl-2 pb-1 pt-1 pr-2">
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleIncreaseMinQuantity(offeritem.minQuantity, offeritem.price);
                      return false;
                    }}
                  >
                    {'ADD ' + offeritem.name}
                  </a>
                </span>
              </p>
            ))}
          </div>

          {showCartButton ? (
            <div className="container col-lg-12 col-md-6">
              <span className="float-left">
                <button
                  className="btn custom-rounded-btn px-3 btn-sm text-white fw-bold"
                  style={{ backgroundColor: 'Salmon', fontWeight: 'bold' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToCart();
                  }}
                >
                  ADD
                </button>
              </span>
            </div>
          ) : (
            <div className="d-flex flex-column align-items-center mt-2">
              <div>
                <div className="btn-group" role="group" aria-label="Basic example">
                  <button
                    type="button"
                    className="btn-sm inc btn btn-outline-secondary"
                    onClick={(e) => { e.stopPropagation(); handleDecreaseQuantity(); }}
                  >
                    <i className="feather-minus"></i>
                  </button>
                  <a
                    href="#"
                    className="btn-sm btn btn-outline-secondary division"
                    style={{ display: 'block' }}
                    onClick={(e) => e.preventDefault()}
                  >
                    {quantity}
                  </a>
                  <button
                    type="button"
                    className="btn-sm dec btn btn-outline-secondary"
                    onClick={(e) => { e.stopPropagation(); handleIncreaseQuantity(); }}
                  >
                    <i className="feather-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MenuItem;
